/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { UserGroup } from '../models';
/**
 * UserEmailApi - axios parameter creator
 * @export
 */
export const UserEmailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Check if a email already in use
         * @param {string} email 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCheckmailGet: async (email: string, userId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('usersCheckmailGet', 'email', email)
            const localVarPath = `/users/checkmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserEmailApi - functional programming interface
 * @export
 */
export const UserEmailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserEmailApiAxiosParamCreator(configuration)
    return {
        /**
         * Check if a email already in use
         * @param {string} email 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersCheckmailGet(email: string, userId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersCheckmailGet(email, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserEmailApi - factory interface
 * @export
 */
export const UserEmailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserEmailApiFp(configuration)
    return {
        /**
         * Check if a email already in use
         * @param {string} email 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCheckmailGet(email: string, userId?: number, options?: any): AxiosPromise<UserGroup> {
            return localVarFp.usersCheckmailGet(email, userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserEmailApi - object-oriented interface
 * @export
 * @class UserEmailApi
 * @extends {BaseAPI}
 */
export class UserEmailApi extends BaseAPI {
    /**
     * Check if a email already in use
     * @param {string} email 
     * @param {number} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserEmailApi
     */
    public usersCheckmailGet(email: string, userId?: number, options?: AxiosRequestConfig) {
        return UserEmailApiFp(this.configuration).usersCheckmailGet(email, userId, options).then((request) => request(this.axios, this.basePath));
    }
}
